// Tablero: colección de palabras (líneas horizontales de fichas).
// En el MVP cada palabra es una secuencia independiente (no crucigrama).
import { uid } from '../utils/helpers.js';
import { effectiveText } from './Tile.js';

export class Board {
  constructor(words = []) {
    // words: [{ id, tiles: [tileInstance...] }]
    this.words = words;
  }

  /**
   * Crea una nueva palabra (grupo) con fichas iniciales y posición LIBRE en la mesa.
   * Si x/z quedan indefinidos, la escena les asigna un hueco automáticamente.
   */
  createWord(tiles = [], x, z) {
    const word = { id: uid('w'), tiles, x, z };
    this.words.push(word);
    return word;
  }

  /** Reposiciona una palabra entera (arrastre estilo Rummikub). */
  moveWord(wordId, x, z) {
    const word = this.getWord(wordId);
    if (word) { word.x = x; word.z = z; }
    return !!word;
  }

  removeWord(wordId) {
    const idx = this.words.findIndex((w) => w.id === wordId);
    if (idx !== -1) this.words.splice(idx, 1);
  }

  getWord(wordId) {
    return this.words.find((w) => w.id === wordId) || null;
  }

  /** Inserta una ficha en una palabra en la posición indicada (o al final). */
  insertTile(wordId, tile, index = -1) {
    const word = this.getWord(wordId);
    if (!word) return false;
    if (index < 0 || index >= word.tiles.length) word.tiles.push(tile);
    else word.tiles.splice(index, 0, tile);
    return true;
  }

  /** Extrae una ficha del tablero por instanceId. Devuelve la ficha o null. */
  removeTile(instanceId) {
    for (const word of this.words) {
      const idx = word.tiles.findIndex((t) => t.instanceId === instanceId);
      if (idx !== -1) {
        const [tile] = word.tiles.splice(idx, 1);
        return tile;
      }
    }
    return null;
  }

  /** Palabra que contiene una ficha concreta. */
  findWordContaining(instanceId) {
    return this.words.find((w) => w.tiles.some((t) => t.instanceId === instanceId)) || null;
  }

  /** Elimina palabras vacías (sin fichas). */
  pruneEmpty() {
    this.words = this.words.filter((w) => w.tiles.length > 0);
  }

  /** Texto concatenado de una palabra. */
  wordText(word) {
    return word.tiles.map((t) => effectiveText(t)).join('');
  }

  /** Todas las fichas colocadas en el tablero. */
  allTiles() {
    return this.words.flatMap((w) => w.tiles);
  }

  isEmpty() {
    return this.words.length === 0;
  }

  toJSON() {
    return this.words;
  }
}
